<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    flat
    height="75"
    :style="!isMobile && isMultiOrg ? 'left:334px' : null"
  >
    <v-btn
      v-if="isMobile"
      style="min-width:22px"
      class="pa-1 text-center mr-3"
      depressed
      small
      text
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon class="mr-0">
        $faBars
      </v-icon>
    </v-btn>

    <div
      v-if="!isInternal"
      class="org-name"
    >
      {{ selectedOrgName }}
    </div>
    <div v-else>
      <v-menu
        v-show="!showList"
        id="internalMenu"
        v-model="topMenuOpen"
        bottom
        :close-on-content-click="false"
        right
        offset-y
        origin="top left"
        transition="scale-transition"
        elevation="24"
        z-index="150"
      >
        <template v-slot:activator="{ attrs, on }">
          <div
            class="org-name"
            v-bind="attrs"
            v-on="on"
          >
            {{ selectedOrgName }}
            <v-icon
              v-if="showList"
              right
              x-small
            >
              $faChevronDown
            </v-icon>
          </div>
        </template>
        <v-sheet
          :dark="$vuetify.theme.dark"
          :light="$vuetify.theme.light"
          :min-width="isMobile ? '300' : '550'"
          min-height="auto"
        >
          <valkyrie-list
            :list-data="listData"
            :pagination="listPagination"
            :list-name="'Organizations'"
            :headers.sync="headers"
            :is-loading.sync="loading"
            class="menu-list"
            rows-selectable
            @update-pagination="handleUpdatePagination"
            @select-row="selectRow"
          >
            <template v-slot:list-header>
              <default-list-header
                searchable
                in-menu
                @search="handleUpdateSearch"
                @clear-org="clearOrgSelection"
              />
            </template>
          </valkyrie-list>
        </v-sheet>
      </v-menu>
    </div>
    <v-spacer />

    <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mobile">
      <account-icon
        :size="36"
        @click.native="toggleAccountDrawer"
      />
    </v-app-bar-nav-icon>
    <account-menu v-else />
  </v-app-bar>
</template>

<script>
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import ValkyrieList from '@/components/ValkyrieList.vue'
  import AccountMenu from './AccountMenu.vue'
  import AccountIcon from '@/components/base/AccountIcon.vue'
  import listMixin from '@/helpers/list-mixin'
  import listControllerMixin from '@/helpers/list-controller-mixin'
  import DefaultListHeader from '@/components/ValkyrieListDefaultHeader.vue'

  export default {
    name: 'DashboardCoreAppBar',
    components: { ValkyrieList, AccountMenu, AccountIcon, DefaultListHeader },
    mixins: [listMixin, listControllerMixin],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      topMenuOpen: false,
      payload: {
        listType: 'orgs',
      },
      total: 0,
      headers: [
        {
          text: 'Name',
          value: 'nameAndId',
        },
        {
          text: 'Properties',
          value: 'propertyCount',
        },
      ],
    }),
    computed: {
      ...mapState(['drawer', 'accountDrawer']),
      ...mapGetters({
        currentUser: 'Users/currentUser',
        selectedOrg: 'Permissions/currentSelectedOrg',
        isMultiOrg: 'Permissions/isMultiOrg',
        isInternal: 'Permissions/isInternal',
      }),
      isMobile () {
        return this.$vuetify.breakpoint.mobile
      },
      filterBy () {
        return this.currentUser.id
      },
      selectedOrgName () {
        return this.selectedOrg.name ? this.selectedOrg.name : 'All Organizations'
      },
      selectedOrgId () {
        return this.selectedOrg ? this.selectedOrg.id : ''
      },
      showList () {
        return this.currentUser.orgs.length > 1 || this.currentUser.role === 'internal'
      },
      listAPIPath () {
        return `${this.$store.state.baseURL}/orgs/list`
      },
      listPagination () {
        return { ...this.pagination, total: this.total }
      },
    },
    created () {
      if (this.showList) this.initializeAppBarList()
    },
    beforeDestroy () {
      clearInterval(this.timeout)
    },
    methods: {
      ...mapMutations(['setDrawer']),
      initializeAppBarList () {
        this.fetchList().then((res) => { this.total = res.data.pagination.total })
      },
      selectRow (item) {
        this.$store.commit('Organizations/setSelectedOrg', item)
        this.topMenuOpen = false
      },
      clearOrgSelection () {
        this.$store.commit('Organizations/setSelectedOrg', undefined)
        this.topMenuOpen = false
      },
      toggleAccountDrawer () {
        this.$store.commit('setAccountDrawer', !this.accountDrawer)
      },
    },
  }
</script>
<style lang="scss">
#app-bar {
  position: fixed;
  top:0;
  z-index: 5;
  &.theme--light {
    background-color: $na-dark-cream;
  }
  & > .v-toolbar__content {
    padding: 0 30px;
  }
}
.menu-list div.v-data-footer__select {
  visibility: hidden;
}
.org-name {
  font-family: 'Lato', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #{$base};
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
